export const isGridApiValid = (gridApi) => {
  return !!gridApi && typeof gridApi.isDestroyed === 'function' && !gridApi.isDestroyed();
};
